module.exports = __webpack_public_path__ + "static/media/YER_Fall2017.1fc8d677.pdf";